module.exports = __webpack_public_path__ + "static/img/5.9c44e18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/2/5.png
// module id = F1dK
// module chunks = 1